import { Box, Button, Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { RoleBasedContent } from './RoleBasedContent.tsx';
import PatientList from './patient/PatientList.tsx';

const HomePatients = () => {
  const navigate = useNavigate();

  const goToPatientInitPage = () => {
    navigate('/patient/init');
  };

  return (
    <Container sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <RoleBasedContent
          component={
            <Button onClick={goToPatientInitPage} variant="contained">
              Inclure un nouveau patient
            </Button>
          }
          roles={['doctor', 'arc']}
        />
      </Box>
      <PatientList />
    </Container>
  );
};
export default HomePatients;
